import React from "react";

const MixedRichtext = ({ data }) => {

  let mixedRich = data.primary;

  return (
    <React.Fragment>
      {mixedRich.include_callout && (
        <aside className="sidebar-content">
          <div className="box style-1">
            <h3 className="tag">{mixedRich.body_callout_label.text || ""}</h3>
            <div className="callout-text" dangerouslySetInnerHTML={{ __html: mixedRich.body_callout_text.html || "" }}></div>
            {mixedRich.body_callout_link?.url && (
              <a href={mixedRich.body_callout_link.url} className="btn btn-primary">
                {mixedRich.body_callout_link_text} →
              </a>
            )}
          </div>
        </aside>
      )}
      <div dangerouslySetInnerHTML={{ __html: mixedRich?.body_content?.html }}></div>
    </React.Fragment>
  )
}

export default MixedRichtext;